import { useRef, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { AUDIO_CLICK_URL } from '../constants/audioAssets'

const CLICK_SOUND_PATH = AUDIO_CLICK_URL

export const useClickSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const lastPlayTimeRef = useRef<number>(0)
  const DEBOUNCE_MS = 50 // Minimum time between sounds (50ms)
  
  const clickSoundEnabled = useSelector(
    (state: RootState) => state.app.settings.clickSoundEnabled
  )

  const playClickSound = useCallback(() => {
    // Check if click sound is enabled
    if (!clickSoundEnabled) {
      return
    }

    try {
      const now = Date.now()
      // Debounce: don't play if sound was played recently
      if (now - lastPlayTimeRef.current < DEBOUNCE_MS) {
        return
      }

      // Create audio element if it doesn't exist
      if (!audioRef.current) {
        audioRef.current = new Audio(CLICK_SOUND_PATH)
        audioRef.current.volume = 0.3 // Set volume to 30%
      }

      // Reset and play
      audioRef.current.currentTime = 0
      audioRef.current.play().catch((err) => {
        // Silently fail if audio can't play (e.g., user hasn't interacted yet)
        console.debug('Click sound playback failed:', err)
      })
      
      lastPlayTimeRef.current = now
    } catch (error) {
      console.debug('Click sound error:', error)
    }
  }, [clickSoundEnabled])

  return playClickSound
}

